import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_feature_potential_team_kpi = {
	id: "REPORT_feature_potential_team_kpi",
	name: "Funkcje potencjał - nieaktywne - według zepołów",
	description:
		"Raport pokazuje ilość featuer w lokalizacjach po dacie ustawienia potencjału, które mają ustawiony potencjał ale nie są aktywne ani używane",
	data: [
		{
			id: "ORGANIZATION_FEATURE",
			resource: "ORGANIZATION_FEATURE",
			filter: "sold_by_partner_type|e={partner_type}çusage_type|e=MONTHLYçenabled|false",
			groups: ["NONE", "SOLD_BY_PARTNER"],
			columns: [
				{
					id: "summary",
					filter: "sold_by_partner_at|bt={date_range__QUARTER}",
				},
				{
					id: "monthly",
					group: "SOLD_BY_PARTNER_AT_MONTH",
					filter: "sold_by_partner_at|bt={date_range__QUARTER}",
				},
			],
		},
	],
	table: [
		{
			id: "products_progress",
			rows: [
				{
					id: "ORGANIZATION_FEATURE",
					name: "Funkcje",
					data_id: "ORGANIZATION_FEATURE",
					group: "NAME",
					aggregate_columns: {
						count: "potential_count",
						points: "potential_points",
						count_monthly: "potential_count",
						points_monthly: "potential_points",
						subscription_count: "subscription_count",
					},
				},
			],
			columns: [
				{
					id: "count",
					data_column_id: "summary",
					name: "Potencjał",
					url_options: {
						groups: ["ORGANIZATION_NAME"],
					},
				},
				{
					id: "count_monthly",
					data_column_id: "monthly",
					name: "Potencjalne",
					values_dynamic: "values_previous_3_months",
					url_options: {
						groups: ["ORGANIZATION_NAME"],
					},
				},
				{
					id: "points",
					data_column_id: "summary",
					name: "Punkty",
					url_options: {
						groups: ["ORGANIZATION_NAME"],
					},
				},
				{
					id: "points_monthly",
					data_column_id: "monthly",
					name: "Użycia",
					values_dynamic: "values_previous_3_months",
					url_options: {
						groups: ["ORGANIZATION_NAME"],
					},
				},
				{
					id: "subscription_count",
					data_column_id: "summary",
					name: "Subskrypcje",
					url_options: {
						groups: ["ORGANIZATION_NAME"],
					},
				},
			],
		},
	],
} as ConfigReportComboApi;
